import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { isEmpty, length } from 'ramda'
import strings from 'utils/strings'

import DividerPipe from 'components/DividerPipe'

import {
  Switch,
  PartDescription,
  PartInfoList,
  PartInfoContainer,
  PartVehicleModel,
  PartNumber,
  CollapsibleSwitchList,
  SwitchPartListHeader,
} from './InputSwitchList.style'

const InputSwitchList = ({ currentInputOrOutputSwitches, marginTop }) => {
  const hasSwitches = !isEmpty(currentInputOrOutputSwitches)
  const renderSwitch = ([key, value]) => {
    // Sort ascending so "Plus Series" always precedes "X-Series" — deterministic heading across API orderings
    const panelDesc = [...value]
      .sort((a, b) =>
        (a.vehicleSubTypeLabel || '').localeCompare(b.vehicleSubTypeLabel || '')
      )
      .find((sw) => sw.panelDescription)?.panelDescription
    const hasList = length(value) > 1
    return (
      <Switch
        key={key}
        className={`switch-details-${key.replace(/[^a-zA-Z0-9-_]/g, '-')}`}
      >
        <PartDescription>{panelDesc ? `${panelDesc}:` : ''}</PartDescription>
        <PartInfoList>
          {value.map((switchVal, index) => {
            const { panelNumber, vehicleSubTypeLabel } = switchVal
            return (
              <PartInfoContainer
                key={`switch-number-model-${vehicleSubTypeLabel}-${panelNumber}`}
              >
                <PartVehicleModel>{`${vehicleSubTypeLabel}:`}</PartVehicleModel>
                <PartNumber>{panelNumber}</PartNumber>
                {index === 0 && hasList && <DividerPipe />}
              </PartInfoContainer>
            )
          })}
        </PartInfoList>
      </Switch>
    )
  }

  const renderSwitchInventory = useMemo(
    () =>
      hasSwitches &&
      Object.entries(currentInputOrOutputSwitches).map(renderSwitch),
    [currentInputOrOutputSwitches, hasSwitches]
  )

  const collapsibleSwitchListHeader = (
    <SwitchPartListHeader className="collapsible-switch-list-header">
      {strings.possible_part_inventory}
    </SwitchPartListHeader>
  )

  return (
    <CollapsibleSwitchList
      marginTop={marginTop}
      panelClassName="possible-part-collapsible-panel"
      header={collapsibleSwitchListHeader}
    >
      {renderSwitchInventory}
    </CollapsibleSwitchList>
  )
}

InputSwitchList.propTypes = {
  currentInputOrOutputSwitches: PropTypes.object,
  marginTop: PropTypes.string.isRequired,
}

export default InputSwitchList
